import React, { useContext } from 'react';
import { Comment } from '../Comment';
import { PostForm } from '../PostForm';
import { AppContext } from '../../../../../../AppContext';
import './CommentsList.scss';

export function CommentsList({ disabled, comments, replyId, onKarma, onCancelPost, onReply, onReplyPost }) {
  const { user } = useContext(AppContext);

  return (
    <ul className="CommentsList">
      {comments.map((comment) => (
        <li className="CommentsList__item" key={comment.id}>
          <Comment comment={comment} onKarma={onKarma} onReply={onReply} />

          {user.type !== 'guest' && replyId === comment.id && (
            <PostForm disabled={disabled} onCancel={onCancelPost} onPost={onReplyPost} />
          )}

          {comment.replies && (
            <CommentsList
              comments={comment.replies}
              replyId={replyId}
              onKarma={onKarma}
              onCancelPost={onCancelPost}
              onReply={onReply}
              onReplyPost={onReplyPost}
            />
          )}
        </li>
      ))}
    </ul>
  );
}
